<template>
  <div
    class="modal-container row align-items-center text-center"
    :class="classNames ? classNames : null"
    @click.self="closeWhenDismisable"
    @keyup.esc="closeWhenDismisable"
  >
    <div class="hl-modal small-container prose mx-auto p-5 bg-white" :style="withStyle">
      <div v-if="dismisable" @click="closeModal" class="close-modal">
        <i class="budicon-cross-ui"></i>
      </div>
      <div v-if="iconClass" class="mb-5 mt-3">
        <i :class="iconClass"></i>
      </div>

      <h3 v-if="title" class="heading-large mt-3 mb-5">{{ title }}</h3>

      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    iconClass: String,
    dismisable: Boolean,
    classNames: String,
    width: {
      type: String,
      default: '100%',
    },
  },
  computed: {
    withStyle() {
      return `width: ${this.width}`;
    },
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },

    closeWhenDismisable() {
      if (this.dismisable) {
        this.closeModal();
      }
    },

    closeModalOnESC(e) {
      if (e.keyCode === 27) {
        this.closeWhenDismisable();
      }
    },
  },

  mounted() {
    document.body.addEventListener('keyup', this.closeModalOnESC);
    document.body.style.overflow = 'hidden';
  },

  beforeDestroy() {
    document.body.removeEventListener('keyup', this.closeModalOnESC);
    document.body.style.overflow = 'scroll';
  },
};
</script>

<style scoped lang="scss">
.modal-container {
  background: rgba($gray-500, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1111;
  margin: 0;
  overflow-y: scroll;

  .hl-modal {
    width: 100%;
    border: 1px solid $gray-100;
    border-radius: $border-radius;
    box-shadow: $box-shadow-3;
    position: relative;
    z-index: 1120;

    i {
      font-size: 2.4rem;
    }

    .close-modal {
      position: absolute;
      right: 1.4rem;
      top: 1.4rem;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background: $gray-200;
      border: 1px solid $gray-200;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: $transition-base;
      color: $gray-700;
      cursor: pointer;

      i {
        font-size: 1rem;
        padding-top: 2px;
      }
    }

    .close-modal:hover {
      background: $gray-200;
      border: 1px solid $gray-300;
      color: $gray-900;
    }
  }

  &.upsell-modal {
    @media (max-width: 1023px) {
      display: flex;
      flex-direction: column-reverse;
    }
    .hl-modal {
      border-radius: 20px 20px 0 0;
      padding: 55px 30px !important;
      text-align: left;

      @media (min-width: 767px) {
        padding: 55px 15% !important;
      }

      @media (max-width: 1023px) {
        max-width: 100%;
      }

      @media (min-width: 1023px) {
        padding: 55px 80px !important;
        border-radius: 20px;
      }

      .close-modal {
        border: 0;
        i {
          &::before {
            font-size: 36px;
          }
        }
      }
    }
  }

  &.api-error-modal {
    .hl-modal {
      border-radius: 20px;
      padding: 80px 0 !important;

      h3 {
        font-size: 30px;
        font-weight: 600;
        padding-bottom: 10px;
      }
      i {
        display: inline-block;
        font-size: 8rem;
        margin-bottom: 20px;
      }
    }
  }
  &.centered-mobile {
    padding: 20px;
    > .hl-modal {
      @media (max-width: 1023px) {
        margin: auto;
        border-radius: 20px;
      }
    }
  }
}
</style>
